const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/defs/device.ts';
export enum DeviceType {
    TABLET = 'TABLET',
    DESKTOP = 'DESKTOP',
    PHONE = 'PHONE'
}

export enum DeviceOrientation {
    PORTRAIT= 'PORTRAIT',
    LANDSCAPE= 'LANDSCAPE',
}